import { reservationAxios } from '../../../core/rest/axios';
export async function createReservation(data) {
    return reservationAxios.post('/objednani', data);
}
export async function cancelReservation(data) {
    return reservationAxios.post('/objednani/zrusit-dle-hash?hash=' + data.hash, data);
}
